(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ke-email"] && !Shopify.designMode) return;
  try {
    (() => {
    const wire = (root) => {
      root.querySelectorAll('[data-ke-e]').forEach((el) => {
        const addr = el.getAttribute('data-ke-e').split('').reverse().join('');
        el.removeAttribute('data-ke-e');
        if (!el.hasAttribute('data-ke-label')) {
          el.textContent = addr;
          el.style.unicodeBidi = 'normal';
          el.style.direction = 'ltr';
        }
        let target = null;
        if (el.tagName === 'A') target = el;
        else if (el.parentElement && el.parentElement.tagName === 'A') target = el.parentElement;
        if (target) {
          const arm = () => target.setAttribute('href', 'mailto:' + addr);
          target.addEventListener('pointerenter', arm, { once: true });
          target.addEventListener('focus', arm, { once: true });
          target.addEventListener('touchstart', arm, { once: true, passive: true });
          target.addEventListener('click', arm, { once: true });
        }
      });
    };
    if (document.readyState !== 'loading') wire(document);
    else document.addEventListener('DOMContentLoaded', () => wire(document));
    document.addEventListener('shopify:section:load', (e) => wire(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
